let collectionHiddenCount = 0;
let totalProductsFetched = 0;
let limit = 250; // Max number of products per request
let productGrid = document.getElementById('product-grid');
let collectionHandle = productGrid.getAttribute('current-collection-handle');


function fetchProducts(page) {
  totalProductsFetched = 0;
  $.getJSON(`/collections/${collectionHandle}/products.json?limit=${limit}&page=${page}`, function(data) {
    totalProductsFetched += data.products.length;

    collectionHiddenCount = 0;
    data.products.forEach(function(product) {
      if (product.tags.includes('collection-hidden')) {
       // console.log('product title: ',product.title);
        collectionHiddenCount++;
      }
    });

    // Check if there are more products to fetch
    if (data.products.length === limit) {
      fetchProducts(page + 1); // Fetch the next page
    } else {
      // All products fetched, display the final count
      // console.log('Number of products with "collection-hidden" tag: ' + collectionHiddenCount);
      $('#hidden-product-count').text(collectionHiddenCount);
      GetProductFinalCount(collectionHiddenCount);
       let pagekey = window.location.pathname;
       localStorage.setItem(pagekey + '-hidden-products', collectionHiddenCount);
    }
  });
}


function GetProductFinalCount(hiddenProd){

const totalItemsElement = document.querySelector('.total-items');
let totalItemValue = parseInt(totalItemsElement.getAttribute('total-item-value'));
let updatedValue = totalItemValue - hiddenProd;
// console.log("totalItemValue",totalItemValue)
// console.log("updatedValue",updatedValue)
// console.log("hiddenProd",hiddenProd)
// totalItemsElement.setAttribute('total-item-value', updatedValue);
// totalItemsElement.textContent = `of ${updatedValue}`;

}


fetchProducts(1);


function getHiddenProductCount(){
  // console.log('calling hidden product count calculator');
  let pagekey = window.location.pathname;
  if (localStorage.getItem(pagekey + '-hidden-products')) {
                let hidden_count = localStorage.getItem(pagekey + '-hidden-products');
                // console.log('hidden product count ',hidden_count);
                GetProductFinalCount(hidden_count);
            }
}
